<template>
  <div>

    <div class="warp">

      <!-- 面包屑 -->

      <!-- <breadcrumb :back="false" :crubList="[{name:'首页推荐管理管理'},{name:'平台热点管理列表'}]" :title="'平台热点管理列表'"/> -->
      <div ref="condition">
      <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="新闻咨讯" name="1"></el-tab-pane>
              <el-tab-pane label="政策咨询" name="2"></el-tab-pane>
            </el-tabs>

      <el-button
        class="addbtns"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addbtn"
        v-if="authorities.indexOf('sys:permission:background:hotpoint:add')!=-1"
      >添加热点</el-button>
      </div>

      <!-- 表格 -->

      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
       fit
        :height="bHeight"
        :header-cell-style="headerStyle"
        v-loading="loading"
        element-loading-text="请求中......"
      >

        <el-table-column
          prop="sort"
          show-overflow-tooltip
          
          label="序号"
          width="80px"
        >

        </el-table-column>

        <el-table-column
          prop="title"
          show-overflow-tooltip
          
          label="资讯标题"
          width="600px"
        >

        </el-table-column>

        <el-table-column
          prop="referee"
          show-overflow-tooltip
          
          label="推荐人"
        >

        </el-table-column>

        <el-table-column
          prop="refereeTime"
          show-overflow-tooltip
          
          label="推荐时间"
        >

        </el-table-column>

        <el-table-column
          v-if="authorities.indexOf('sys:permission:background:hotpoint:edit')!=-1 ||
                                                (authorities.indexOf('sys:permission:background:hotpoint:del')!=-1)"
          label="操作"
          
          width="200px"
        >

          <template slot-scope="scope">

            <el-button
              size="small" type="primary" class="super" plain
              @click="editoer(scope.row)"
              v-if="authorities.indexOf('sys:permission:background:hotpoint:edit')!=-1"
            >编辑

            </el-button>

            <el-button
              v-if="authorities.indexOf('sys:permission:background:hotpoint:del')!=-1"
              size="small" type="danger" class="super" plain
              @click="deleteDell(scope.row.id)"
            >删除

            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加热点 -->
      <el-dialog
        title="添加热点"
        :visible.sync="dialogAdd"
        :before-close="resetForm"
        :close-on-click-modal='false'
        width="400"
      >
        <el-form
        v-if="dialogAdd"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="资讯名称"
            prop="advisoryId"
            class="formitem"
             v-if="!edit"
          >
            <el-select
              v-model="ruleForm.advisoryId"
              placeholder="请选择资讯名称"
              filterable
              clearable
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item,index) in newsDataSelect"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-else class="nametitle"><div>资讯名称</div>  {{ruleForm.title}}</div>
          <el-form-item
            label="序号"
            prop="sort"
          >
            <el-input
              v-model="ruleForm.sort"
              placeholder="请输入"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
            >确认</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components: {
        // breadcrumb,
    },
    data() {
        return {
            loading:false,
            tab: '1',
            bHeight: void 0,
            authorities: JSON.parse(window.localStorage.getItem('authorities')),
            sendInfo: {
                currentPage: 1, //页码
                pageSize: 9999, //条数
            }, //检索提交数据
            tableData: [], //表格数据
            totalPage: null, //总页码
            dialogAdd: false,
            classifyList: [], //分类
            newsDataSelect: [],
            ruleForm: {
                advisoryId: null,
                sort: null,
            },
            edit: false, //是否编辑
            rules: {
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                advisoryId: { required: true, message: '请选择咨询名称', trigger: 'change' }
            }
        }
    },
    watch: {
        tab: function() {
            this.getData()
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods: {
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        changeTab(tab) {
            this.tab = tab.name
        },
        // 添加按钮
        addbtn() {
            // this.edit = false
            // this.getSelect()
            this.$router.push({path:`/HomePageMgt/PlatformHotspotList/add/${this.tab}`,query:{index:'/HomePageMgt/PlatformHotspotList'},params:{type:this.tab}})
        },
        submitForm(formName) {
            console.log(this.ruleForm)
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!that.edit) {
                        that.$axioscBody.post(that.tab === '1' ? 'backstage/hotpoint/news/add' : 'backstage/hotpoint/guide/add', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                await that.getData();
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    } else {
                        that.$axioscBody.put(that.tab === '1' ? 'backstage/hotpoint/news/edit' : 'backstage/hotpoint/guide/edit', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                await that.getData()
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    }

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
          this.ruleForm={
                advisoryId: null,
                sort: null,
            },
          this.dialogAdd = false
          // this.$refs[formName].resetField();
        },
        deleteDell(id) {
            const  that = this
            that.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const {code,msg} = await that.$axiosc.delete(that.tab === '1' ? '/backstage/hotpoint/news/del' : '/backstage/hotpoint/guide/del', { params: { id: id } })
                if (code == 200) {
                        that.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                       await that.getData()
                    }else {
                        that.$alert(msg)
                    }
            }).catch(() => {});
        },
        // 编辑回显
        editoer(row) {
            // this.ruleForm = row
            // this.edit = true;
            // this.dialogAdd = true
            this.$router.push({path:`/HomePageMgt/PlatformHotspotList/edit/${this.tab}/${row.id}`,query:{index:'/HomePageMgt/PlatformHotspotList'},params:{id:row.id,type:this.tab}})
        },
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfo.pageSize = val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfo.currentPage = val;
            this.getData();
        },
        //取消按钮
        cancel: function(type) {
            this.dialogAdd = false;
        },
        //获取数据
        async getData() {
          try{
            this.loading = true
            const {data,code,msg} = await this.$axiosc.get(this.tab === '1' ? 'backstage/hotpoint/news/list' : 'backstage/hotpoint/guide/list', { params: this.sendInfo })
            this.loading = false
            if (code == 200) {
                this.tableData = data || [];
            } else {
                this.$alert(msg)
            }
          }catch(e){
            this.loading = false
          }
        },
        async getSelect() {
            const that = this
            const {code,data,msg} = await that.$axiosc.get(this.tab==='1'?'/backstage/hotpoint/news/select':'/backstage/hotpoint/guide/select', {})
            if (code == 200) {
                    that.newsDataSelect = data || [];
                } else {
                    that.$alert(msg)
                }
            that.dialogAdd = true

        }
    },
    mounted() {
        const that = this
        that.getData();
        let bh = 44 + that.$refs.condition.offsetHeight +  30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + that.$refs.condition.offsetHeight +  30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>
<style scoped="scoped" lang="scss">
/deep/ .nametitle{
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 32px;
  div{
  margin-right: 10px;

  }
}
.forms {
    /deep/ .el-select {
        width: 300px;
    }
    .child {
        .remark {
            /deep/ .el-textarea__inner {
                min-height: 122px !important;
            }
        }
        .name {
            width: 123px;
        }
    }
}

.tabs {
    border: 0;
}

.addbtns {
    margin: 0px 0 10px;
}

/deep/ .el-dialog {
    width: 450px;
}
.main{
  padding: 30px 20px 20px;
}
</style>
